import React, { useState } from 'react';

function Contact() {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        serviceType: '',
        preferredDate: '',
        details: '',
    });
    const [status, setStatus] = useState(null);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        // Validate required fields
        if (!formData.name || !formData.email || !formData.serviceType) {
            setStatus({ type: 'error', message: 'Please fill out all required fields.' });
            return;
        }
        // Email format validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(formData.email)) {
            setStatus({ type: 'error', message: 'Please enter a valid email address.' });
            return;
        }

        // Simulate submission
        setTimeout(() => {
            setStatus({
                type: 'success',
                message: 'Thanks for requesting a quote! We will reach out soon.',
            });
            setFormData({
                name: '',
                email: '',
                serviceType: '',
                preferredDate: '',
                details: '',
            });
        }, 1000);
    };

    return (
        <main className="container my-5" style={{ maxWidth: '600px' }}>
            <h1 className="mb-4 text-center">Request a Free Cleaning Quote</h1>

            <form onSubmit={handleSubmit} noValidate>
                <div className="mb-3">
                    <label htmlFor="name" className="form-label">
                        Full Name <span className="text-danger">*</span>
                    </label>
                    <input
                        type="text"
                        id="name"
                        name="name"
                        className="form-control"
                        placeholder="Your full name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                    />
                </div>

                <div className="mb-3">
                    <label htmlFor="email" className="form-label">
                        Email Address <span className="text-danger">*</span>
                    </label>
                    <input
                        type="email"
                        id="email"
                        name="email"
                        className="form-control"
                        placeholder="you@example.com"
                        value={formData.email}
                        onChange={handleChange}
                        required
                    />
                </div>

                <div className="mb-3">
                    <label htmlFor="serviceType" className="form-label">
                        Type of Cleaning <span className="text-danger">*</span>
                    </label>
                    <select
                        id="serviceType"
                        name="serviceType"
                        className="form-select"
                        value={formData.serviceType}
                        onChange={handleChange}
                        required
                    >
                        <option value="">Select a service</option>
                        <option value="Residential">Residential Cleaning</option>
                        <option value="Commercial">Commercial Cleaning</option>
                        <option value="Rental">Rental / Airbnb Cleaning</option>
                    </select>
                </div>

                <div className="mb-3">
                    <label htmlFor="preferredDate" className="form-label">
                        Preferred Cleaning Date (optional)
                    </label>
                    <input
                        type="date"
                        id="preferredDate"
                        name="preferredDate"
                        className="form-control"
                        value={formData.preferredDate}
                        onChange={handleChange}
                        min={new Date().toISOString().split('T')[0]} // no past dates
                    />
                </div>

                <div className="mb-3">
                    <label htmlFor="details" className="form-label">
                        Additional Details / Questions
                    </label>
                    <textarea
                        id="details"
                        name="details"
                        className="form-control"
                        rows="5"
                        placeholder="E.g., size of property, specific areas to focus on, special requests..."
                        value={formData.details}
                        onChange={handleChange}
                    />
                </div>

                {status && (
                    <div
                        className={`alert ${status.type === 'success' ? 'alert-success' : 'alert-danger'}`}
                        role="alert"
                    >
                        {status.message}
                    </div>
                )}

                <button type="submit" className="btn btn-primary w-100">
                    Request Quote
                </button>
            </form>
        </main>
    );
}

export default Contact;
